module.exports = __webpack_public_path__ + "static/media/search.40c3b28a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/search.svg
 ** module id = 438
 ** module chunks = 0
 **/